import { useState, useEffect, useCallback } from "react";
import "./RoleCard.scss";
import { notification } from "antd";
import service from "../../services/Service.js";
import { withLocale } from '../../l10n/index.jsx';
import Loading from "../../utils/loading.jsx";
import withNavigation from '../hooks/withNavigation.jsx';
import { useDispatch } from 'react-redux';
import { lookupApi } from '../../services/lookupApi.js';

function RoleCard({ ident, navigate, lang, editable }) {
  // ===== 1. ESTADOS =====
  const [ui, setUI] = useState({
    loading: false,
  });

  const [form, setForm] = useState({
    uuid: "",
    name: "",
    items: [],
    itemName: "",
  });

  // ====== 2. SELECTORES/HOOKS ========
  const dispatch = useDispatch();

  // ===== 3. HELPERS =====
  const updateUI = (field, value) => setUI(prev => ({ ...prev, [field]: value }));
  const updateForm = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  // ===== 4. FUNCIONES PRINCIPALES =====
  const Pfetch = useCallback(async () => {
    if (!ident) return;

    updateUI("loading", true);
    try {
      const res = await service.get("roles/" + ident);
      if (res.data.ok === false) {
        notification["error"]({
          message: lang.handle(res.data.message),
        });
        return;
      }
      const data = res.data[0];
      setForm({
        uuid: data.uuid,
        name: data.name,
        items: data.items || [],
        itemName: data.itemName || "",
      });
    } catch (err) {
      console.log("Error devuelto: " + err);
    } finally {
      updateUI("loading", false);
    }
  }, [ident, lang]);

  // ===== 5. HANDLERS =====
  const onInputChange = (e) => {
    updateForm(e.target.name, e.target.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!ident) {
        const res = await service.post("roles", form);
        if (res.data.ok === false) {
          notification["error"]({
            message: lang.handle(res.data.message),
          });
        } else {
          notification["success"]({
            message: lang.handle('Rol creado correctamente'),
          });
          dispatch(lookupApi.util.invalidateTags(['Roles']));
          navigate("/users/roles");
        }
      } else {
        const res = await service.put("roles/" + form.uuid, form);
        if (res.data.ok === false) {
          notification["error"]({
            message: lang.handle(res.data.message),
          });
        } else {
          notification["success"]({
            message: lang.handle('Rol actualizado correctamente'),
          });
          dispatch(lookupApi.util.invalidateTags(['Roles']));
          navigate("/users/roles");
        }
      }
    } catch (err) {
      console.log("Error devuelto: " + err);
    }
  };

  // ===== 6. EFFECTS =====
  useEffect(() => {
    if (ident) {
      Pfetch();
    }
  }, [ident, Pfetch]);

  // ===== 7. RENDER HELPERS =====
  const title = !ident
    ? lang.handle('Nuevo Rol')
    : lang.handle('Información de Rol: ') + form.name;

  // ===== 9. RENDER =====
  return (
    <div className="card">
      {ui.loading && <Loading loading={ui.loading} />}
      <h4 className="card-title p-3"> {title} </h4>

      <form onSubmit={onSubmit} className="p-3">
        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label newCard-form-text"
          >
            {lang.handle('Nombre')}
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              onChange={onInputChange}
              value={form.name}
              disabled={!editable}
            />
          </div>
        </div>

        {editable && (
          <button
            id="button-save"
            className="btn btn-primary d-flex float-right"
            type="submit"
          >
            <div className="btnText">
              <p> {lang.handle('Guardar')}&nbsp;&nbsp; </p>
              <i className="material-icons"> save </i>
            </div>
          </button>
        )}
      </form>
    </div>
  );
}

export default withLocale(withNavigation(RoleCard));
